<ds-panel class="notification-container p-mb-2" [showHeader]="false">
    <div class="notification-header">
        <div class="notification-metadata p-mb-3">
            <div class="p-small notification-date"
                [innerText]="notification.registrationDate | date: 'yyyy-MM-dd HH:mm'"></div>
            <div class="notification-delimiter"></div>
            <ng-container *ngIf="!internalApp">
                <div class="p-small notification-system" [innerText]="notification.module"></div>
                <div class="notification-delimiter"></div>
            </ng-container>
            <div class="p-small notification-cmd" (click)="hideNotification()">Ukryj</div>
            <div *ngIf="showGoUrl" class="p-small notification-cmd p-ml-2" (click)="goNotification()">Przejdź</div>
        </div>
        <i (click)="expanded = !expanded" class="pi pi-chevron-down icon"
            [ngClass]="{ 'pi-chevron-right': !expanded, 'pi-chevron-down': expanded}"></i>
    </div>
    <div class="notification-text" [innerHTML]="notification.type"></div>
    <div class="notification-text-description" *ngIf="notification.description?.length > 0" [innerHTML]="notification.description"></div>
    <div [@slideNotification] *ngIf="expanded" class="animation-container">
        <div class="p-mt-2 notification-content p-small" [innerHTML]="notification.content"></div>
    </div>
</ds-panel>
